import {getRandomFloat} from "../getRandomFloat";

export const getRandomFactors = (factorsCount) => {
  const factorsArr = new Array(factorsCount);
  for (let i = 0; i < factorsCount; i++) {
    factorsArr[i] = getRandomFloat(getRandomFloat(-1.5, 0.5), getRandomFloat(0.5, 1.5));
  }
  return factorsArr;
}